module.exports = __webpack_public_path__ + "static/img/cover.5a6be8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/chinese-fonts/cover.jpg
// module id = O0To
// module chunks = 1